import { Lock, Mail } from "lucide-react";

export default function AccessDenied() {
  return (
    <div dir="rtl" className="min-h-screen bg-stone-950 flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center" data-testid="access-denied">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-stone-800 border border-stone-700 flex items-center justify-center">
          <Lock className="w-10 h-10 text-stone-500" />
        </div>
        <h1 className="font-[Rubik] font-black text-3xl sm:text-4xl text-stone-50 mb-3">
          הכניסה לאזור החברים סגורה
        </h1>
        <p className="text-stone-400 leading-relaxed mb-8">
          אזור החברים פתוח רק לחברי הקהילה שנרשמו לפלטפורמה. הכניסה מתבצעת דרך לינק חד-פעמי שנשלח למייל שלכם לאחר ההרשמה.
        </p>
        <div className="bg-stone-900 border border-stone-800 rounded-2xl p-5 flex items-center gap-3 text-start">
          <Mail className="w-5 h-5 text-amber-500 flex-shrink-0" />
          <div className="text-sm text-stone-300 leading-relaxed">
            בדקו את תיבת המייל שלכם ולחצו על הלינק שקיבלתם. אם המייל לא הגיע, בדקו את תיקיית הספאם או צרו קשר.
          </div>
        </div>
        <a href="/" className="inline-block mt-8 text-sm text-amber-500 hover:text-amber-400 font-bold" data-testid="access-denied-home">
          חזרה לדף הבית ←
        </a>
      </div>
    </div>
  );
}
